const lowercaseText = ["q"];
const importantText = ["live blog", "live chat", "coming up"];

export function hasFlag(cleanedFlag) {
    return cleanedFlag && cleanedFlag !== "none";
}

export function shouldRemainLowercase(cleanedFlag) {
    return lowercaseText.indexOf(cleanedFlag) >= 0;
}

export function isImportantContent(cleanedFlag) {
    return importantText.indexOf(cleanedFlag) >= 0;
}

export function cleanFlag(flag) {
    return String(flag).trim().toLowerCase();
}
